import axios from 'axios'

const state = {

};

const getters = {

};

const actions = {

    getActionPeriods: async () => {
        const datas = {
            token: localStorage.getItem('token'),
        };
        return new Promise((resolve, reject) => {
            axios.get(process.env.VUE_APP_API_URL + "ammon/actions/period", datas, {
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                },
            })
            .then((response) => {
                resolve(response.data);
            })
            .catch((error) => reject(error));
        });
    },

}

const mutations = {

};

export default {
    state,
    getters,
    actions,
    mutations
};